import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default class ToastManager extends Component {
  static showToast(msg: string, title: string) {
    let dealyTime = 3000;
    let hideProgres = true;
    if (title === "Error") {
      toast.error(msg, {
        position: "top-center",
        autoClose: dealyTime,
        hideProgressBar: hideProgres,
      });
    } else if (title === "Success") {
      toast.success(msg, {
        position: "top-center",
        autoClose: dealyTime,
        hideProgressBar: hideProgres,
      });
    } else if (title === "Info") {
      toast.info(msg, {
        position: "top-center",
        autoClose: dealyTime,
        hideProgressBar: hideProgres,
      });
    } else if (title === "Warn") {
      toast.warn(msg, {
        position: "top-center",
        autoClose: dealyTime,
        hideProgressBar: hideProgres,
      });
    }
  }
  render() {
    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }
}
